module.exports = __webpack_public_path__ + "static/crown-residences-rera_page-0001-7ad709fa878dc6fc24afac5b859f7084.jpg";